import script from "./contactBox.vue?vue&type=script&setup=true&lang=js"
export * from "./contactBox.vue?vue&type=script&setup=true&lang=js"

import "./contactBox.vue?vue&type=style&index=0&id=3bf4d76e&lang=scss"

const __exports__ = script;

export default __exports__